export enum ClickAction {
  PROMOTION_NOTIFICATION_TARGET = 'PROMOTION_NOTIFICATION_TARGET',
  SYSTEM_ALERT_NOTIFICATION_TARGET = 'SYSTEM_ALERT_NOTIFICATION_TARGET',
  ADMIN_NEW_SHIPPER_SIGNUP_NOTIFICATION_TARGET = 'ADMIN_NEW_SHIPPER_SIGNUP_NOTIFICATION_TARGET',
  ADMIN_LOAD_CLEARANCE_NOTIFICATION_TARGET = 'ADMIN_LOAD_CLEARANCE_NOTIFICATION_TARGET',
  ADMIN_JOB_APPROVAL_NOTIFICATION_TARGET = 'ADMIN_JOB_APPROVAL_NOTIFICATION_TARGET',
  ADMIN_PAYMENT_RECEIVED_NOTIFICATION_TARGET = 'ADMIN_PAYMENT_RECEIVED_NOTIFICATION_TARGET',
  ADMIN_PAYMENT_DUE_EXPIRING_NOTIFICATION_TARGET = 'ADMIN_PAYMENT_DUE_EXPIRING_NOTIFICATION_TARGET',

  OVERSPEED_NOTIFICATION_TARGET = 'OVERSPEED_NOTIFICATION_TARGET',
  HARSH_ACCELERATION_NOTIFICATION_TARGET = 'HARSH_ACCELERATION_NOTIFICATION_TARGET',
  HARSH_BRAKING_NOTIFICATION_TARGET = 'HARSH_BRAKING_NOTIFICATION_TARGET',
  SHARP_TURN_NOTIFICATION_TARGET = 'SHARP_TURN_NOTIFICATION_TARGET',
  FUEL_DROP_NOTIFICATION_TARGET = 'FUEL_DROP_NOTIFICATION_TARGET',
  FUEL_RISE_NOTIFICATION_TARGET = 'FUEL_RISE_NOTIFICATION_TARGET',
  ENGINE_OVERHEAT_NOTIFICATION_TARGET = 'ENGINE_OVERHEAT_NOTIFICATION_TARGET',

  GEOFENCE_EXIT_NOTIFICATION_TARGET = 'GEOFENCE_EXIT_NOTIFICATION_TARGET',
  GEOFENCE_ENTRY_NOTIFICATION_TARGET = 'GEOFENCE_ENTRY_NOTIFICATION_TARGET',
  MAINTENANCE_DUE_NOTIFICATION_TARGET = 'MAINTENANCE_DUE_NOTIFICATION_TARGET',
  DEVICE_EXPIRY_NOTIFICATION_TARGET = 'DEVICE_EXPIRY_NOTIFICATION_TARGET',
  LICENSE_EXPIRY_NOTIFICATION_TARGET = 'LICENSE_EXPIRY_NOTIFICATION_TARGET',

  VEHICLE_OFFLINE_NOTIFICATION_TARGET = 'VEHICLE_OFFLINE_NOTIFICATION_TARGET',
  LOW_BATTERY_NOTIFICATION_TARGET = 'LOW_BATTERY_NOTIFICATION_TARGET',
  TRACKER_DISCONNECTION_NOTIFICATION_TARGET = 'TRACKER_DISCONNECTION_NOTIFICATION_TARGET',
  TRACKER_BATTERY_LOW_NOTIFICATION_TARGET = 'TRACKER_BATTERY_LOW_NOTIFICATION_TARGET',

  NEW_JOB_NOTIFICATION_TARGET = 'NEW_JOB_NOTIFICATION_TARGET',
  OUTBID_NOTIFICATION_TARGET = 'OUTBID_NOTIFICATION_TARGET',
  CARRIER_DEACTIVATED_NOTIFICATION_TARGET = 'CARRIER_DEACTIVATED_NOTIFICATION_TARGET',
  CARRIER_COUNTER_OFFER_NOTIFICATION_TARGET = 'CARRIER_COUNTER_OFFER_NOTIFICATION_TARGET',
  OFFER_ACCEPTED_CARRIER_NOTIFICATION_TARGET = 'OFFER_ACCEPTED_CARRIER_NOTIFICATION_TARGET',
  ADMIN_BID_APPROVAL_NOTIFICATION_TARGET = 'ADMIN_BID_APPROVAL_NOTIFICATION_TARGET',
  ADMIN_BID_REJECTION_NOTIFICATION_TARGET = 'ADMIN_BID_REJECTION_NOTIFICATION_TARGET',
  BID_LOAD_MODIFIED_NOTIFICATION_TARGET = 'BID_LOAD_MODIFIED_NOTIFICATION_TARGET',
  PICKUP_DATE_APPROACHING_NOTIFICATION_TARGET = 'PICKUP_DATE_APPROACHING_NOTIFICATION_TARGET',
  PAYMENT_RECEIVED_APPROVAL_NOTIFICATION_TARGET = 'PAYMENT_RECEIVED_APPROVAL_NOTIFICATION_TARGET',
  QUOTES_NOTIFICATION_TARGET = 'QUOTES_NOTIFICATION_TARGET',
  ASSIGNED_VEHICLE_NOTIFICATION_TARGET = 'ASSIGNED_VEHICLE_NOTIFICATION_TARGET',
  LOAD_PROGRESS_UPDATE_NOTIFICATION_TARGET = 'LOAD_PROGRESS_UPDATE_NOTIFICATION_TARGET',
  LOAD_DELIVERED_NOTIFICATION_TARGET = 'LOAD_DELIVERED_NOTIFICATION_TARGET',
  ADMIN_LOAD_COMPLETION_APPROVAL_TARGET = 'ADMIN_LOAD_COMPLETION_APPROVAL_TARGET',
  LOAD_COMPLETED_NOTIFICATION_TARGET = 'LOAD_COMPLETED_NOTIFICATION_TARGET',

  VETTING_SUCCESSFUL_NOTIFICATION_TARGET = 'VETTING_SUCCESSFUL_NOTIFICATION_TARGET',
  VETTING_FAILED_NOTIFICATION_TARGET = 'VETTING_FAILED_NOTIFICATION_TARGET',

  SHIPPER_COUNTER_OFFER_NOTIFICATION_TARGET = 'SHIPPER_COUNTER_OFFER_NOTIFICATION_TARGET',
  OFFER_ACCEPTED_SHIPPER_NOTIFICATION_TARGET = 'OFFER_ACCEPTED_SHIPPER_NOTIFICATION_TARGET',
  ADMIN_BID_APPROVAL_SHIPPER_NOTIFICATION_TARGET = 'ADMIN_BID_APPROVAL_SHIPPER_NOTIFICATION_TARGET',
  ADMIN_REJECTED_ACCEPTED_LOAD_NOTIFICATION_TARGET = 'ADMIN_REJECTED_ACCEPTED_LOAD_NOTIFICATION_TARGET',
  SHIPPER_JOB_APPROVED_NOTIFICATION_TARGET = 'SHIPPER_JOB_APPROVED_NOTIFICATION_TARGET',
  JOB_EXPIRED_NOTIFICATION_TARGET = 'JOB_EXPIRED_NOTIFICATION_TARGET',
  PAYMENT_OVERDUE_NOTIFICATION_TARGET = 'PAYMENT_OVERDUE_NOTIFICATION_TARGET',

  TERMS_AND_CONDITIONS_UPDATED_NOTIFICATION_TARGET = 'TERMS_AND_CONDITIONS_UPDATED_NOTIFICATION_TARGET',
}
